import React, { useState } from 'react';
import TeacherLogin from './TeacherLogin';
import TeacherDashboard from './TeacherDashboard';

const TeacherPortal = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const handleLogin = () => {
    setIsLoggedIn(true);
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
  };

  return (
    <div>
      {isLoggedIn ? (
        <TeacherDashboard onLogout={handleLogout} />
      ) : (
        <TeacherLogin onLogin={handleLogin} />
      )}
    </div>
  );
};

export default TeacherPortal;